export function readAgentThreadsUrl(runsUrl: string): string {
  const trimmed = runsUrl.trim();
  if (!trimmed) {
    return '';
  }

  try {
    return new URL('/v1/threads', trimmed).toString().replace(/\/$/, '');
  } catch {
    return '';
  }
}

export function readAgentIdFromRunsUrl(runsUrl: string): string {
  const match = runsUrl.trim().match(/\/v1\/agents\/([^/?#]+)\/runs/i);
  return match?.[1] ?? '';
}

export function readAgentUrl(runsUrl: string): string {
  const agentId = readAgentIdFromRunsUrl(runsUrl);
  if (!agentId) {
    return '';
  }

  try {
    return new URL(`/v1/agents/${encodeURIComponent(agentId)}`, runsUrl).toString().replace(/\/$/, '');
  } catch {
    return '';
  }
}

/** Agent GET without `fields=models` omits the configured model list. */
export function readAgentDetailsUrl(runsUrl: string): string {
  const agentUrl = readAgentUrl(runsUrl);
  if (!agentUrl) {
    return '';
  }

  try {
    const url = new URL(agentUrl);
    url.searchParams.append('fields', 'models');
    return url.toString();
  } catch {
    return '';
  }
}
